/**
 * Event name dispatched by `<o2d-whiteboard>` when a copy leaves the picture off the system
 * clipboard for a reason the user should hear about. Prefixed like `whiteboard-changed` and
 * `whiteboard-command` to avoid collisions with other libraries.
 */
export const WHITEBOARD_CLIPBOARD_IMAGE_SKIPPED_EVENT = 'whiteboard-clipboard-image-skipped' as const;

/**
 * Detail of the `whiteboard-clipboard-image-skipped` event.
 *
 * - `reason: 'multiple-images'`: two or more images were copied. One clipboard entry carries
 *   one picture, so none was put there; the board objects were still copied (Stefan,
 *   2026-10-28). The package shows nothing itself — the host decides how to tell the user.
 * - `imageCount`: how many image objects the copy held.
 */
export interface WhiteboardClipboardImageSkippedEventDetail {
  readonly reason: 'multiple-images';
  readonly imageCount: number;
}

/** Type alias for the `whiteboard-clipboard-image-skipped` CustomEvent. */
export type WhiteboardClipboardImageSkippedEvent = CustomEvent<WhiteboardClipboardImageSkippedEventDetail>;

// Global augmentation: addEventListener('whiteboard-clipboard-image-skipped', ...) is typed for
// any consumer that imports from '@o2d/whiteboard'. Compile-time only.
declare global {
  interface HTMLElementEventMap {
    'whiteboard-clipboard-image-skipped': WhiteboardClipboardImageSkippedEvent;
  }
}
